import { arrayx } from "@deathbycode/fp-ts-ext"
import { toBreadcrumbPath } from "app/categories/breadcrumbPath"
import { HasName } from "app/common/core/types"
import { CategoryForestVM2, CategoryVM, CategoryWithSubcategoriesVM2 } from "app/models"
import { array, eq, nonEmptyArray, ord, string } from "fp-ts"
import { pipe } from "fp-ts/function"

const sort = array.sort(ord.contramap((cat: HasName) => cat.name)(string.Ord))

const sortTree = <A extends HasName & { subcategories: A[] }>(cat: A[]): A[] =>
  pipe(
    cat,
    sort,
    array.map((c) => ({
      ...c,
      subcategories: sortTree(c.subcategories),
    }))
  )

export const categoryForestToTree = (forest: CategoryVM[]): CategoryForestVM2 => {
  return pipe(
    forest,
    array.chain(toBreadcrumbPath),
    array.uniq(eq.fromEquals((a, b) => a.slugPath.join("/") === b.slugPath.join("/"))),
    array.reduce({} as Record<string, CategoryWithSubcategoriesVM2>, (m, { name, slugPath }) => {
      const key = slugPath.join("/")

      const c: CategoryWithSubcategoriesVM2 = {
        name,
        slugPath,
        subcategories: [],
      }

      m[key] = c

      if (arrayx.isMultiple(slugPath)) {
        pipe(slugPath, nonEmptyArray.init, (parentKey) => {
          m[parentKey.join("/")]?.subcategories.push(c)
        })
      }

      return m
    }),
    Object.values,
    array.filter((c) => arrayx.isSingle(c.slugPath)),
    sortTree
  )
}
